window.addEventListener('load', function() {
    setTimeout(function() {
      var instaLinks = document.querySelectorAll('.instafeed-fullname');
      
      instaLinks.forEach(function(link, index) {
        link.setAttribute('tabindex', '-1');
        link.setAttribute('aria-hidden', 'true');
        
        var currentHref = link.getAttribute('href');
        if (currentHref && !currentHref.includes('ref=text')) {
          var separator = currentHref.includes('?') ? '&' : '?';
          link.setAttribute('href', currentHref + separator + 'ref=text-' + index);
        }
      });
    }, 2500);
});